import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import api from '../../../services/api';
import { TextField, FormGroup, Container } from '@mui/material';
import * as Yup from 'yup';
import '../styles.css';
import Progress from '../../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';
import { setDisable } from '../../../redux/disable';
import { setLoading } from '../../../redux/loading';
import Success from '../../../components/Snack/Success';
import Error from '../../../components/Snack/Error';
import { useStyles } from '../../../components/Styles';
import GroupButton from '../../../components/Buttons/ButtonGroup';

function WaterSource() {
  const [openProgress, setOpenProgress] = useState(false);
  const disable = useSelector((state) => state.disable.disable);
  const error = Error();
  const success = Success();
  const history = useHistory();
  const dispatch = useDispatch();
  const { id } = useParams();
  const classes = useStyles();

  const formik = useFormik({
    initialValues: {
      name: '',
      type: '',
      extraction: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Campo Obrigatório'),
      type: Yup.string().required('Campo Obrigatório'),
      extraction: Yup.string().required('Campo Obrigatório'),
    }),
    onSubmit: (values) => {
      dispatch(setDisable(true));
      dispatch(setLoading(true));

      request(values);
    },
  });

  useEffect(() => {
    async function load() {
      // carrega caso tenha id, do contrario carrega vazio para cadastrar um novo
      if (id) {
        setOpenProgress(true);
        const request = await api.get(`/water-sources/${id}`);
        formik.setValues(request.data);
        setOpenProgress(false);
      }
    }
    load();
  }, []);

  async function request(data) {
    // envia os dados para api salvar no banco
    try {
      id
        ? await api.put(`/water-sources/${id}`, { ...data })
        : await api.post('/water-sources', { ...data });
      success();
      history.push('/water-sources');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  return (
    <Container>
      {openProgress ? <Progress /> : null}
      <form onSubmit={formik.handleSubmit}>
        <div className={classes.root}>
          <h2 className="title">Dados de Fonte de Água</h2>

          <FormGroup>
            <TextField
              InputLabelProps={{ style: { pointerEvents: 'auto' } }}
              id="name"
              label={<div>Nome</div>}
              variant="outlined"
              name="name"
              type="text"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.name && formik.errors.name}
              helperText={
                formik.touched.name && formik.errors.name && formik.errors.name
              }
            />
          </FormGroup>
          <FormGroup>
            <TextField
              InputLabelProps={{ style: { pointerEvents: 'auto' } }}
              id="type"
              label={<div>Tipo</div>}
              variant="outlined"
              name="type"
              type="text"
              value={formik.values.type}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.type && formik.errors.type}
              helperText={
                formik.touched.type && formik.errors.type && formik.errors.type
              }
            />
          </FormGroup>
          <FormGroup>
            <TextField
              InputLabelProps={{ style: { pointerEvents: 'auto' } }}
              id="extraction"
              label={<div>Descrição</div>}
              variant="outlined"
              name="extraction"
              type="text"
              value={formik.values.extraction}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.extraction && formik.errors.extraction}
              helperText={
                formik.touched.extraction
                && formik.errors.extraction
                && formik.errors.extraction
              }
            />
          </FormGroup>
        </div>

        <GroupButton
          deleteRoute="/water-sources/"
          routeDelete="/water-sources"
          returnRoute="/water-sources"
          id={id}
          disable={disable}
          message="A funcionário dessa biometria pode levar a exclusão de objetos que dependam dele. Tem certeza que deseja excluir?"
        />
      </form>
    </Container>
  );
}

export default WaterSource;
